function ServiceCard({ title, description, icon }) {
	return (
		<div className="border p-6 rounded-lg shadow-lg bg-white hover:shadow-xl transition-all">
			<div className="text-5xl mb-4">{icon}</div>
			<h3 className="text-2xl font-semibold mb-2">{title}</h3>
			<p>{description}</p>
		</div>
	);
}

export default ServiceCard;
